import { computed } from 'vue';

import { storeToRefs } from 'pinia';

import { resolveMarketplaceTimeZone } from '@/helpers/dateHelpers.js';
import { useAccountStore } from '@/stores/account.js';

/**
 * IANA time zone date-times show in on a marketplace page outside an OLAP grid (which reads it
 * from its grid context instead): the current marketplace's, else the business profile's
 * default marketplace zone, else UTC. Never the browser zone.
 * @returns {import('vue').ComputedRef<string>}
 */
export const useMarketplaceTimeZone = () => {
  const { currentBusinessProfile, currentMarketplace } = storeToRefs(useAccountStore());
  return computed(() =>
    resolveMarketplaceTimeZone({
      marketplace: currentMarketplace.value,
      businessProfile: currentBusinessProfile.value,
    }),
  );
};
